import { render } from "./HomepageUlb.vue?vue&type=template&id=f2a3b76e&scoped=true"
import script from "./HomepageUlb.vue?vue&type=script&lang=js"
export * from "./HomepageUlb.vue?vue&type=script&lang=js"

import "./HomepageUlb.vue?vue&type=style&index=0&id=f2a3b76e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a3b76e"]])

export default __exports__